import { createTheme } from "@mui/material/styles";


const theme = createTheme({
    fonts: {
        primary: "Roboto",
    },
    palette: {
        primary: {
            main: "#2A68F8",
            lightBlue: "#0077b6",
        }
    }
})

export default theme;